module.exports = __webpack_public_path__ + "img/layout-three-columns.3c45a92b.svg";